export const themeColors = {
    primary: '#383258',
    secondary: '#F6F5E6',
}
